// extracted by mini-css-extract-plugin
export default {"footer-social-links":"footer-social-links--51pnx","footerSocialLinks":"footer-social-links--51pnx"};